<div class="tab-switch" role="tablist" [attr.aria-label]="ariaLabel">
  @for (tab of tabs; track tab.id) {
    <button
      type="button"
      role="tab"
      [class.active]="activeTab === tab.id"
      [class.disabled]="!!tab.disabled"
      [disabled]="!!tab.disabled"
      [attr.aria-selected]="activeTab === tab.id"
      (click)="selectTab(tab)"
    >
      @if (tab.icon) {
        <mat-icon>{{ tab.icon }}</mat-icon>
      }
      {{ tab.label }}
    </button>
  }
</div>
